export default function() {

  // Start import status poll if importing
  let companyUpdatingPoll = () => {

    // Get generating message on page
    let isGenerating = $('.updating-polling');

    // Only continue if status indicator present (if should poll for recs is true)
    if (isGenerating.length !== 0) {

      // Set url to get data
      let recordId = isGenerating.data('record-id');
      let url = isGenerating.data('url');
      if (typeof url === 'undefined') {
        url = '/companies/' + recordId + '/poll_updating_status.js';
      }

      // Execute ajax request (using js erb template to render content so can control profile styling more easily)
      // Must specify '.js' otherwise processes as JSON
      $.ajax({
        type: "POST",
        dataType: "script",
        timeout: 3000,
        url: url,
        complete() {
          setTimeout(function() { companyUpdatingPoll() }, 4000);
        }
      });
    }
  };

  // Poll server for status of mapped items, if generating message present
  if ($('.updating-polling').length !== 0) { companyUpdatingPoll(); }

}